import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import SubNavPhotography from "./SubNavPhotography";
import Feature from "./Feature";
import "./category.css";

const clients = [
  {
    id: "omg",
    name: "Oil My Goodness",
    desc: "Oil My Goodness",
    features: [
      {
        id: 1,
        desc:
          "Oil My Goodness-OMG is an all-natural skincare brand that is here for one thing: to give people a better, healthier alternative. Since 2010, They have been an advocate of the power of mother nature when it comes to beauty.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542876134/rtds_work/OMG/DSC_1034.jpg"
      },
      {
        id: 2,
        desc:
          "And you thought a good pose is only done by humans. It doesn't matter who or what, we'll capture it for you.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542829659/rtds_work/OMG/DSC_1301.png"
      }
    ]
  },
  {
    id: "mck",
    name: "MCK",
    desc: "MKC",
    features: [
      {
        id: 1,
        desc:
          "MCK Fresh Flowers is provides flowers in supermarkets and big malls like SM, Robinsons, Shopwise and Rustans. They sell fresh cut flowers local and imported. They make arrangements for any occasions and accepts flower delivery to selected locations.",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1542897906/rtds_work/MCK/MCKPoster3-eMockup.jpg"
      },
      {
        id: 2,
        desc:
          "If you are in need of fresh cut flowers, for your loved ones, a party or you want to start a flower business of your own, then MCK Fresh Flowers is perfect for you!",
        img:
          "https://res.cloudinary.com/doddfudab/image/upload/v1555272555/rtds_work/MCK/rtds_work_MCK_DSC_1041_landscape.jpg"
      }
    ]
  }
];

class Photography extends Component {
  render() {
    const id = this.props.match.params.id;
    const selected = clients.filter((item, i) => item.id === id);
    return (
      <div className="photography">
        <div className="banner-container">
          <span className="banner-text">Snap every moment of your life!</span>
          <div className="banner">
            <img
              src="https://res.cloudinary.com/doddfudab/image/upload/v1555250071/rtds_work/photography/dslr.png"
              alt="banner"
              className="banner"
            />
          </div>
        </div>
        <SubNavPhotography />
        {selected[0] ? (
          <Feature
            data={selected[0] ? selected[0].features : []}
            desc={selected[0].desc}
          />
        ) : (
          <Feature
            data={clients[0] ? clients[0].features : []}
            name={clients[0].name}
            desc={clients[0].desc}
          />
        )}
      </div>
    );
  }
}

export default withRouter(Photography);



// WEBPACK FOOTER //
// ./src/components/pages/category/Photography.js